import { Chart } from 'primereact/chart';
import { FC, useEffect, useState } from 'react';
import { BarChartData } from './WeeklyHistoryModal';

interface Props {
  dataChart: BarChartData[];
}

const WeeklyHistoryChart: FC<Props> = ({ dataChart }) => {
  const [chartData, setChartData] = useState({});
  const [chartDataLoading, setChartDataLoading] = useState<boolean>(true);
  const options = {
    maintainAspectRatio: false,
    aspectRatio: 1,
    responsive: true,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        title: {
          display: true,
          text: '% of students',
        },
        stacked: true,
        ticks: {
          stepSize: 20,
          min: 0,
          max: 100,
        },
      },
    },
  };

  useEffect(() => {
    const data = {
      labels: dataChart.map(el => el.label),
      datasets: [
        {
          type: 'bar',
          label: 'Goal Met',
          backgroundColor: '#008158',
          data: dataChart.map(el => String(el.passed)),
          borderColor: 'white',
          borderWidth: 2,
        },
        {
          type: 'bar',
          label: 'Goal Not Met',
          backgroundColor: '#9c9b9b',
          data: dataChart.map(el => String(el.notPassed)),
          borderColor: 'white',
          borderWidth: 2,
        },
      ],
    };
    setChartData(data);
    setChartDataLoading(false);
  }, [dataChart.length]);

  return (
    chartData &&
    !chartDataLoading && (
      <div>
        <p style={{ fontFamily: 'Poppins' }}>Students meeting 2 skills per week goal</p>
        <div className="nc_chart-modal">
          <Chart type="bar" data={chartData} options={options} />
        </div>
      </div>
    )
  );
};

export default WeeklyHistoryChart;
